import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15 10H5V11H15V10Z" fill="#4F4F4F" />
  </svg>
);

export default SVGComponent;
